import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { AgreementList } from './AgreementList';

export const AgreementListPage = () => {
  useTitle('Список соглашений');

  return (
    <Layout withFooter>
      <AgreementList />
    </Layout>
  );
};
